import UserService from "../../utils/authentification/keycloak";

const RenderOnRole = ({ roles, children }) => {
  const listOfRoles = [...roles, "SuperAdmin"];
  if (UserService.hasRole(listOfRoles)) return children;
  else return null;
};

export default RenderOnRole;
